/**
 * @file Route guard components.
 * @description Provides authentication guards for protected and public-only route branches.
 * @author Sanjay Jangid (Jiggle frontend)
 * @email sanjay.jangid@dgtoohl.com
 * @date 2026-05-10
 * @version 0.0.0
 */
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService } from '../services/authService';

interface GuardProps {
  children: JSX.Element;
}

export function RequireAuth({ children }: GuardProps) {
  const location = useLocation();

  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export function PublicOnlyRoute({ children }: GuardProps) {
  if (AuthService.isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
